import React, { useContext, useEffect, useState } from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Button,
  Box,
} from "@mui/material";

import EChartsReact from "echarts-for-react";
import * as echarts from "echarts";
import DataContext from "../../../context/users/DataContextCopy";

function AsconSpotMonitor() {
  const {
    asconLastData,
    asconClickedItem,
    setAsconClickedItem,
    asconHourData,
    asconNodeId,
    setAsconNodeId,
  } = useContext(DataContext);

  const [chartOptionsList, setChartOptionsList] = useState([]);
  const myPanel = {
    TABLE: 0,
    GRAPH: 1,
  };

  const [panelViewType, setTableShow] = useState(myPanel.TABLE);
  const tableClick = () => {
    setTableShow(myPanel.TABLE);
  };

  const graphClick = () => {
    setTableShow(myPanel.GRAPH);
  };
  // 테이블
  useEffect(() => {
    try {
      if (asconLastData.length === 0) {
        return;
      }

      let filteredItems = asconLastData.find(
        (item) => item?.name === asconClickedItem.name
      );

      // filteredItems에 대한 처리 또는 상태 업데이트
      setAsconClickedItem(filteredItems);
      // console.log(filteredItems);
    } catch (error) {
      console.error("Error fetching filtered data:", error.message);
    }
  }, [asconLastData, asconClickedItem]);

  // 측정시간
  const clickedItemIntime = () => {
    try {
      if (asconClickedItem) return asconClickedItem.intime[0].slice(0, 16);
      else return "0000-00-00 00:00";
    } catch {
      return "0000-00-00 00:00";
    }
  };

  // 풍향
  const clickedItemWind = () => {
    try {
      if (asconClickedItem) return asconClickedItem?.wind_dir;
      else return "";
    } catch {
      return "";
    }
  };

  const CTableBody = () => {
    try {
      return (
        <TableBody key={asconClickedItem.node_id}>
          {asconClickedItem.sensor_name.map((sensor, idx) => (
            <TableRow key={sensor.id}>
              <TableCell sx={{ textAlign: "center" }}>
                {asconClickedItem.sensor_name[idx]}
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "center",
                  color: getColor(asconClickedItem.grade[idx]),
                  fontWeight: "bold",
                }}
              >
                {asconClickedItem.value[idx]}
              </TableCell>
              <TableCell sx={{ textAlign: "center" }}>
                {asconClickedItem.sensor_unit[idx]}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      );
    } catch {
      return <></>;
    }
  };

  useEffect(() => {
    if (
      !asconClickedItem ||
      !asconHourData ||
      !Array.isArray(asconHourData[asconClickedItem.node_id])
    ) {
      console.log("선택된 지역에 데이터 없음");
      return;
    }

    // 클릭된 지역의 데이터만 필터링합니다
    const regionData = asconHourData[asconClickedItem.node_id];

    // 각 데이터 항목에 대해 차트 옵션을 설정합니다
    const __chart__ = regionData
      .filter((babyRegion) => babyRegion.name !== "풍향") // "풍향" 제외
      .map((babyRegion) => {
        // 가장 최근 데이터를 가져옵니다
        const latestItem = asconLastData.find((lastItem) =>
          lastItem.sensor_name.includes(babyRegion.name)
        );

        // 단위값을 설정합니다
        if (latestItem) {
          const unitIndex = latestItem.sensor_name.indexOf(babyRegion.name);
          babyRegion.unit =
            unitIndex !== -1 && latestItem.sensor_unit
              ? latestItem.sensor_unit[unitIndex]
              : ""; // 단위값 처리
        } else {
          babyRegion.unit = ""; // 기본값
        }

        // 차트 옵션을 생성합니다
        return HourChartOptions(babyRegion);
      });

    // 생성된 차트 옵션을 상태에 설정합니다
    setChartOptionsList(__chart__);
    console.log(__chart__);
  }, [asconClickedItem, asconHourData, asconLastData]);

  const colors = [
    "#F8C4B4",
    "#B8E8FC",
    "#BCE29E",
    "#D8B4F8",
    "#F7E987",
    "#8CABFF",
    "#EC8F5E",
  ];

  // 차트
  const HourChartOptions = (filteredData) => {
    const name = filteredData?.name;
    const unit = filteredData?.unit;
    const vals = filteredData?.vals.reverse();
    const time = filteredData?.intime
      .map((date) => date.slice(5, 13) + "시")
      .reverse();

    return {
      title: {
        text: name + " " + unit,
        left: "left",
      },
      xAxis: {
        type: "category",
        data: time,
        boundaryGap: false,
      },
      yAxis: {
        type: "value",
        name: "",
      },
      series: [
        {
          name: name,
          type: "line",
          data: vals,
          itemStyle: {
            color: colors[Math.floor(Math.random() * colors.length)],
          },
          label: {
            show: false,
            formatter: "{c}",
          },
        },
      ],
      tooltip: {
        trigger: "axis",
        formatter: "{b0}: {c0}",
      },
      legend: {
        show: false,
      },
    };
  };

  const getColor = (grade) => {
    switch (grade) {
      case "":
        return "#5c8cdd";
      case "notice":
        return "#65b24b";
      case "attention":
        return "#e2d058";
      case "warning":
        return "#ec7a7a";
      case "over":
        return "#ec7a7a";
      default:
        return "#717b84";
    }
  };
  // 좋음 보통 나쁨 매우나쁨 - 색
  const getGradeTextColor = (__grade__) => {
    if (__grade__ === 1 || __grade__ === "좋음") {
      return " #5c8cdd";
    } else if (__grade__ === 2 || __grade__ === "보통") {
      return "#65b24b";
    } else if (__grade__ === 3 || __grade__ === "나쁨") {
      return "#e2d058";
    } else if (__grade__ === 4 || __grade__ === "매우나쁨") {
      return "#ec7a7a";
    }

    return "#717b84";
  };

  return (
    <div className="asconSpotMonitor">
      <Box className="spotDiv" sx={{ bgcolor: "background.default" }}>
        <Box
          className="spotTitle"
          sx={{ bgcolor: "background.default", color: "text.primary" }}
        >
          <h3>{asconClickedItem.name} 대기질 정보</h3>
          <p>
            측정시간: &nbsp;
            {clickedItemIntime() !== -2 ? clickedItemIntime() + "분" : "점검중"}
          </p>
          {clickedItemWind() ? <p>풍향: {clickedItemWind()}</p> : ""}
        </Box>

        <div className="rainbow">
          <div className="rainbow-box">
            <small>좋음</small>
          </div>
          <div className="rainbow-box">
            <small>보통</small>
          </div>
          <div className="rainbow-box">
            <small>나쁨</small>
          </div>
          <div className="rainbow-box">
            <small>매우나쁨</small>
          </div>
        </div>
        <div className="btn">
          <Button
            className={panelViewType === myPanel.TABLE ? "show" : "basic"}
            onClick={() => {
              tableClick();
            }}
          >
            표
          </Button>
          <Button
            className={panelViewType === myPanel.GRAPH ? "show" : "basic"}
            onClick={() => {
              graphClick();
            }}
          >
            그래프
          </Button>
        </div>
      </Box>
      <div className="spotModal">
        <TableContainer
          className="spotTableContainer"
          style={{
            display: panelViewType === myPanel.TABLE ? "block" : "none",
          }}
          component={Paper}
        >
          <Table aria-label="a dense table" size="small" className="spotTable">
            <TableHead>
              <TableRow>
                <TableCell sx={{ textAlign: "center" }}>물질명</TableCell>
                <TableCell sx={{ textAlign: "center" }}>측정값</TableCell>
                <TableCell sx={{ textAlign: "center" }}>단위</TableCell>
              </TableRow>
            </TableHead>
            <CTableBody />
          </Table>
        </TableContainer>
        <div
          className="chart"
          style={{
            display: panelViewType === myPanel.GRAPH ? "block" : "none",
            textAlign: "center",
          }}
        >
          {chartOptionsList.map((item, index) => (
            <EChartsReact
              key={index}
              option={item}
              style={{
                height: "400px",
                width: "100%",
                backgroundColor: "#fff",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default AsconSpotMonitor;
